import { useOrganization } from '@/features/configs/organization';
import { useBasketMutating } from '@/hooks/useBasketMutating';
import { useSelector } from '@/redux';
import { isConveyanceInFlight } from '@/redux/orderStatus/reducer';

/**
 * Whether the diner may open the Select Location pop-up. Single-location brands have
 * nothing to switch to (the org flag, as the checkout indicator and pickup gate use).
 * While a basket write or a cart migration is in flight the pill is disabled, the
 * same rule as the header's order-type toggle.
 */
export function useLocationPickerState() {
  const { data: organizationConfig } = useOrganization();
  const isSingleLocation = Boolean(
    organizationConfig?.locations?.features?.isSingleLocation?.enabled,
  );
  const conveyanceInFlight = useSelector(isConveyanceInFlight);
  const basketMutating = useBasketMutating();
  const cartMigrationType = useSelector((state) => state.app.global.cartMigration?.type);

  return {
    canChange: !isSingleLocation,
    busy: conveyanceInFlight || basketMutating || Boolean(cartMigrationType),
  };
}
